import React from 'react';
import { useQuery, Loading, Error} from 'react-admin';
import moment from 'moment'
import HtmlToReact from 'html-to-react'
var HtmlToReactParser = HtmlToReact.Parser;
var htmlToReactParser = new HtmlToReactParser();

const ViewDetails = ({records, ftype}) =>{
    var tags= []; 
    //console.log(records)
    const { data, loading, error } = useQuery({ 
        type: 'getList',
        resource: 'checklistdetails',
        payload:  {
            pagination: { page: 1 , perPage: 20 },
            filter: {cid: records.id , field_type: ftype},
            sort: { field: 'id', order: 'ASC' }
        }
    });
 
    if (loading) return <Loading />;
    if (error) return <Error />;
    if (!data) return null;

    tags.push(
        data.map(record => (
            <tr >
                <td style={{fontWeight:'bold'}}> {record.proced} </td>
                <td>{htmlToReactParser.parse(record.referance)}</td>
                <td>{record.introduced_date && moment(record.introduced_date).format('MM/DD/yyyy')} </td>
                <td>{record.trainer_init} </td>
                <td>{record.trainee_init} </td>
                <td>{record.proficient_date && moment(record.proficient_date).format('MM/DD/yyyy')} </td>
            </tr>
        ))
    )
    
   // console.log(tags)
    return (
        <>{tags}</>
    )
                
}

export default ViewDetails